import styled from 'styled-components/macro';

export const TransitLocationTrack = styled.div`
`;

export const TransitLocationEmptyState = styled.div`
  padding-bottom: ${(props) => props.theme.spacing(20)};
  padding-top: ${(props) => props.theme.spacing(20)};
  text-align: center;
`;

export const VisibilityAppTrackPill = styled.div`  
  display:inline-flex;    
  background-color: ${(props) => props.theme.palette.orange[100]};
  font-size: ${({ theme }) => theme.typography.sizes.small};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  color: ${(props) => props.theme.palette.white};
  border-radius: 10px;
  margin: 0px ${(props) => props.theme.spacing(10)} ${(props) => props.theme.spacing(5)} 0px;
  padding: ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(12)}; 
`;
